export const VALIDATION_ERROR_PATTERNS = [
  'unique constraint failed',
  'already taken',
  'already exists',
  'validation failed',
  'invalid input',
  'required field',
  'must be',
  'should be',
  'username already exists'
];

